import { useCallback, useEffect, useState } from "react";
import { ChartAreaLoader } from "../../../../components/Loading";
import Tooltip from "../../../../components/tooltip";
import NewFilterContainer from "../../../../components/NewFilterContainer ";
import FilterMenu from "../../../../components/FilterMenu";
import MainPageContainer from "../../../../components/MainPageContainer";
import SecondaryHeader from "../../../Rajasthan/Demand/SecondaryHeader";
import { useSelector } from "react-redux";
import {
  getBuyerSellersData,
  getBuyerSellersTrendData,
  getAvailableEntities,
} from "../../../../Rest_api/RestApi";
import { SearchBox } from "../../../../components/Search";
import { DemoFilterData } from "../../../../store/state/UtilizationData";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../components/recharts/functions";
import { ReMixChart } from "../../../../components/recharts/ReMixCharts";
import { BrushStart, ChartType } from "../../../../models/chart_model";
import { GripVertical, Crown, Zap, Search } from "lucide-react";
import BuyerSellerChart from "./TopBuyersSellersPopup";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

const exchanges = ["IEX", "PXIL", "HPX"];
const products = ["DAM", "RTM", "GDAM", "HPDAM"];
const regions = ["WRLDC", "ERLDC", "NRLDC", "SRLDC", "NERLDC"];
const type = ["Buyers & Sellers", "Regions", "Trends"];

const formatDateToDDMMYYYY = (date: Date) => {
  return date.toLocaleDateString("en-GB").replace(/\//g, "-");
};

const BuyersAndSellers = () => {
  const [loading, setLoading] = useState(false);
  const [selectedExchanges, setSelectedExchanges] = useState<string[]>([
    exchanges[0],
  ]);
  const [selectedTypes, setSelectedTypes] = useState<string>(type[0]);
  const [selectedProducts, setSelectedProducts] = useState<string[]>([
    products[0],
  ]);
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  const [data, setData] = useState<{
    region_buyer: any[];
    region_seller: any[];
    buyer: any[];
    seller: any[];
  }>({ region_buyer: [], region_seller: [], buyer: [], seller: [] });
  const [selectedRegion, setSelectedRegion] = useState<string[]>([
    regions[0],
    regions[1],
    regions[2],
    regions[3],
    regions[4],
  ]);

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateToDDMMYYYY(dates.startDate);
    const endDateStr = formatDateToDDMMYYYY(dates.endDate);
    const formData = new FormData();
    formData.append("start_date", startDateStr);
    formData.append("end_date", endDateStr);
    formData.append("exchange", selectedExchanges.join(","));
    formData.append("product", selectedProducts.join(","));
    formData.append("region", selectedRegion.join(","));
    const data = await getBuyerSellersData(formData);
    setData(data || {});
    setLoading(false);
  }, [
    DefaultDates,
    activeTab,
    selectedExchanges,
    selectedProducts,
    selectedRegion,
  ]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  return (
    <div className="gas-page-container">
      <NewFilterContainer>
        <div className="side-filters-container text-nowrap">
          <FilterMenu
            title="Group By"
            items={type.map((item) => item)}
            selectedItems={[selectedTypes]}
            onSelect={(item, index) => {
              setSelectedTypes(type[index]);
            }}
          />
          <FilterMenu
            title="Exchanges"
            items={exchanges.map((item) => item)}
            selectedItems={selectedExchanges}
            setSelectedItems={setSelectedExchanges}
          />
          <FilterMenu
            title="Products"
            items={products.map((item) => item)}
            selectedItems={selectedProducts}
            setSelectedItems={setSelectedProducts}
          />

          <FilterMenu
            title="Regions"
            items={regions.map((item) => item)}
            selectedItems={selectedRegion}
            setSelectedItems={setSelectedRegion}
          />
        </div>
      </NewFilterContainer>

      <MainPageContainer>
        <SecondaryHeader showViewMode={false} />
        <div className="gas-chart-container">
          {loading ? <ChartAreaLoader title="Loading Buyers & Sellers" subtitle="Fetching exchange buyers and sellers data…" /> : (<>
          {/* <div className="gas-heading gap-x-10">
            <h2 className="chartHeading w-60">Buyers & Sellers</h2>
          </div> */}

          <div
            style={{ height: "calc(100vh - 200px)" }}
          // className="grid grid-cols-1 lg:grid-cols-2 gap-6 "
          >
            {selectedTypes === "Buyers & Sellers" && (
              <>
                <BuyerSellerChartTab data={data} />
              </>
            )}

            {selectedTypes === "Regions" && (
              <>
                <RegionTab data={data} />
              </>
            )}

            {selectedTypes === "Trends" && (
              <>
                <TrendsTab
                  selectedExchanges={selectedExchanges}
                  selectedProducts={selectedProducts}
                  selectedRegion={selectedRegion}
                />
              </>
            )}
          </div>
          </>)}
        </div>
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip note={<p>Exchange Analytics</p>} text=" ">
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </MainPageContainer>
    </div>
  );
};

export default BuyersAndSellers;

function formatMWh(n: number) {
  if (!isFinite(n)) return "0.00";
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function SectionCard({
  title,
  accent,
  count,
  total,
  topName,
  children,
}: {
  title: string;
  accent: string;
  count: number;
  total: number;
  topName?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 h-full flex flex-col overflow-hidden shadow-sm">
      <div
        className="flex items-center justify-between px-5 py-3 border-b border-gray-100"
        style={{
          background: `linear-gradient(90deg, ${accent}14 0%, transparent 60%)`,
        }}
      >
        <div className="flex items-center gap-3 min-w-0">
          <span
            className="w-1 h-8 rounded-full shrink-0"
            style={{ background: accent }}
          />
          <div className="min-w-0">
            <h4 className="text-base flex gap-x-0 items-center font-semibold text-[#6F6D7C] leading-tight">
              <span className="relative flex h-2 w-2">
                <span
                  className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping"
                  style={{ background: accent }}
                />
                <span
                  className="relative inline-flex rounded-full h-2 w-2"
                  style={{ background: accent }}
                />
              </span>
              &nbsp; {title}
            </h4>
            <div className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-gray-500">
              <span className="text-gray-500">Total Volume:</span>
              <span className="font-semibold text-[#6F6D7C]">
                {formatMWh(total)} MWh
              </span>
              {topName && (
                <>
                  <span className="w-1 h-1 rounded-full bg-gray-300" />
                  <span className="flex items-center gap-1 truncate">
                    <Crown className="w-3 h-3" style={{ color: accent }} />
                    <span className="truncate text-[11px] text-gray-500">
                      {topName}
                    </span>
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        <span
          className="flex items-center gap-1.5 text-[11px] font-medium px-3 py-1 rounded-full shrink-0"
          style={{ background: `${accent}1A`, color: accent }}
        >
          <Zap className="w-3.5 h-3.5" fill={accent} strokeWidth={2} />
          {count} active
        </span>
      </div>
      <div className="p-0 flex-1 overflow-x-hidden overflow-y-auto">
        {children}
      </div>
    </div>
  );
}

function BuyerSellerChartTab({ data }: { data: any }) {
  const buyers = data.buyer || [];
  const sellers = data.seller || [];
  const totalBuy = buyers.reduce(
    (s: number, i: { value: number }) => s + (i.value || 0),
    0
  );
  const totalSell = sellers.reduce(
    (s: number, i: { value: number }) => s + (i.value || 0),
    0
  );
  const activeBuyers = buyers.filter(
    (b: { value: number }) => b.value > 0
  ).length;
  const activeSellers = sellers.filter(
    (s: { value: number }) => s.value > 0
  ).length;
  const topBuyer = [...buyers].sort(
    (a: any, b: any) => (b.value || 0) - (a.value || 0)
  )[0];
  const topSeller = [...sellers].sort(
    (a: any, b: any) => (b.value || 0) - (a.value || 0)
  )[0];

  const BUY_ACCENT = "#F59E0B";
  const SELL_ACCENT = "#34656D";

  return (
    <div className="flex flex-col gap-4 h-full">
      <PanelGroup className="flex-1 min-h-0" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          <SectionCard
            title="Top Buyers"
            accent={BUY_ACCENT}
            count={activeBuyers}
            total={totalBuy}
            topName={topBuyer?.name}
          >
            <div className="max-h-[calc(100vh-270px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={buyers}
                showLegend={false}
                type="buyer"
                theme="light"
              />
            </div>
          </SectionCard>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          <SectionCard
            title="Top Sellers"
            accent={SELL_ACCENT}
            count={activeSellers}
            total={totalSell}
            topName={topSeller?.name}
          >
            <div className="max-h-[calc(100vh-270px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={sellers}
                showLegend={false}
                type="seller"
                theme="light"
              />
            </div>
          </SectionCard>
        </Panel>
      </PanelGroup>
    </div>
  );
}

function RegionTab({ data }: { data: any }) {
  const regionBuyers = data.region_buyer || [];
  const regionSellers = data.region_seller || [];
  const totalBuy = regionBuyers.reduce(
    (s: number, i: { value: number }) => s + (i.value || 0),
    0
  );
  const totalSell = regionSellers.reduce(
    (s: number, i: { value: number }) => s + (i.value || 0),
    0
  );
  const activeBuyerRegions = regionBuyers.filter(
    (b: { value: number }) => b.value > 0
  ).length;
  const activeSellerRegions = regionSellers.filter(
    (s: { value: number }) => s.value > 0
  ).length;
  const topBuyerRegion = [...regionBuyers].sort(
    (a: any, b: any) => (b.value || 0) - (a.value || 0)
  )[0];
  const topSellerRegion = [...regionSellers].sort(
    (a: any, b: any) => (b.value || 0) - (a.value || 0)
  )[0];

  const BUY_ACCENT = "#F59E0B";
  const SELL_ACCENT = "#34656D";

  return (
    <div className="flex flex-col gap-4 h-full">
      <PanelGroup className="flex-1 min-h-0" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          <SectionCard
            title="Buyers By Region"
            accent={BUY_ACCENT}
            count={activeBuyerRegions}
            total={totalBuy}
            topName={topBuyerRegion?.name}
          >
            <div className="max-h-[calc(100vh-270px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={regionBuyers}
                showLegend={false}
                type="buyer"
                theme="light"
              />
            </div>
          </SectionCard>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={80}>
          <SectionCard
            title="Sellers By Region"
            accent={SELL_ACCENT}
            count={activeSellerRegions}
            total={totalSell}
            topName={topSellerRegion?.name}
          >
            <div className="max-h-[calc(100vh-270px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={regionSellers}
                showLegend={false}
                type="seller"
                theme="light"
              />
            </div>
          </SectionCard>
        </Panel>
      </PanelGroup>
    </div>
  );
}

function TrendsTab({
  selectedExchanges,
  selectedProducts,
  selectedRegion,
}: any) {
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [chartBuyerData, setChartBuyerData] = useState<any[]>([]);
  const [chartSellerData, setChartSellerData] = useState<any[]>([]);
  const [chartBuyerKeys, setChartBuyerKeys] = useState<string[]>([]);
  const [chartSellerKeys, setChartSellerKeys] = useState<string[]>([]);
  const [selectedBuyers, setSelectedBuyers] = useState<any[]>([]);
  const [selectedSellers, setSelectedSellers] = useState<any[]>([]);
  const [availableEntities, setAvailableEntities] = useState<any[]>([]);

  useEffect(() => {
    const fetchEntities = async () => {
      if (DefaultDates[activeTab]?.defaultRangeDate) {
        const dates = DefaultDates[activeTab].defaultRangeDate;
        const startDateStr = dates.startDate.toISOString().split('T')[0];
        const endDateStr = dates.endDate.toISOString().split('T')[0];
        try {
          const entities = await getAvailableEntities({
            start_date: startDateStr,
            end_date: endDateStr
          });
          const options = entities.map((e: any) => ({ label: e.name, value: e.name }));
          setAvailableEntities(options);

          // Default select specific entities requested by user
          if (selectedBuyers.length === 0 && selectedSellers.length === 0 && options.length > 0) {
            const defaultBuyersNames = ["TELANGANA STATE", "GEB STATE", "WBSETCL"];
            const defaultSellersNames = ["ODISHA STATE", "TAMILNADU STATE", "JPL2"];

            const buyers = options.filter((o: any) => defaultBuyersNames.includes(o.value));
            const sellers = options.filter((o: any) => defaultSellersNames.includes(o.value));

            // If some specific entities are not found, we could fallback or just set what we found
            setSelectedBuyers(buyers);
            setSelectedSellers(sellers);
          }
        } catch (error) {
          console.error("Error fetching entities:", error);
        }
      }
    };
    fetchEntities();
  }, [DefaultDates, activeTab]);

  function FormatBuyerSellerData(data: any) {
    if (!data || !data.buyer || !data.seller) {
      return [];
    }
    const transformedData: any[] = [];

    const targetKeys = ["buyer", "seller"];

    targetKeys.forEach((key) => {
      if (data[key] && Array.isArray(data[key])) {
        data[key].forEach((item: any) => {
          // Find MCP from the payload's mcp array
          const mcpForDate = data.mcp?.find(
            (mcp: any) => mcp.date === item.name
          );

          transformedData.push({
            ...item,
            type: key,
            mcp: mcpForDate?.wt_mcp || null,
            date: item.name,
          });
        });
      }
    });

    return transformedData;
  }

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    if (selectedBuyers.length === 0 && selectedSellers.length === 0) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateToDDMMYYYY(dates.startDate);
    const endDateStr = formatDateToDDMMYYYY(dates.endDate);
    const buyers = selectedBuyers.map((b: any) => b.value);
    const sellers = selectedSellers.map((s: any) => s.value);
    const formData = new FormData();
    formData.append("start_date", startDateStr);
    formData.append("end_date", endDateStr);
    formData.append("exchange", selectedExchanges.join(","));
    formData.append("product", selectedProducts.join(","));
    formData.append("region", selectedRegion.join(","));
    formData.append("sellers", sellers.join(","));
    formData.append("buyers", buyers.join(","));
    const data = await getBuyerSellersTrendData(formData);
    setData(FormatBuyerSellerData(data));
    setLoading(false);
  }, [
    DefaultDates,
    activeTab,
    selectedBuyers,
    selectedExchanges,
    selectedProducts,
    selectedRegion,
    selectedSellers,
  ]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  useEffect(() => {
    let filteredData = data.filter((item: any) => item.type === "buyer");

    const par: ChartDataParams = {
      keys: ["date", "mcp"].concat(selectedBuyers.map((b: any) => b.value)),
      groupBy: [],
      volumeKey: ``,
      aggregationKeys: [],
      averageKeys: [],
      averageDuplicationKeys: [],
      priceKey: "",
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setChartBuyerData(cData.data);
    setChartBuyerKeys(cData.keys);
  }, [data, selectedBuyers]);

  useEffect(() => {
    let filteredData = data.filter((item: any) => item.type === "seller");

    const par: ChartDataParams = {
      keys: ["date", "mcp"].concat(selectedSellers.map((s: any) => s.value)),
      groupBy: [],
      volumeKey: ``,
      aggregationKeys: [],
      averageKeys: [],
      averageDuplicationKeys: [],
      priceKey: "",
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setChartSellerData(cData.data);
    setChartSellerKeys(cData.keys);
  }, [data, selectedBuyers, selectedSellers]);

  const createChartObject = (key: string, index: number, buyer: any) => {
    return {
      dataKey: `${buyer.value}`,
      name: `${buyer.label}`,
      unit: "MWh",
    };
  };

  function getBuyersLegends() {
    return selectedBuyers
      .flatMap((buyer: any, index: number) =>
        chartBuyerKeys.map(
          (key, chartIndex) => createChartObject(key, chartIndex, buyer) as any
        )
      )
      .concat([
        {
          dataKey: "mcp",
          name: "MCP",
          unit: "Rs/KWh",
          type: ChartType.Bar,
          yAxisId: "right",
        },
      ]);
  }

  function getSellerLegends() {
    return selectedSellers
      .flatMap((seller: any, index: number) =>
        chartSellerKeys.map(
          (key, chartIndex) => createChartObject(key, chartIndex, seller) as any
        )
      )
      .concat([
        {
          dataKey: "mcp",
          name: "MCP",
          unit: "Rs/KWh",
          type: ChartType.Bar,
          yAxisId: "right",
        },
      ]);
  }

  const BUY_ACCENT = "#F59E0B";
  const SELL_ACCENT = "#34656D";

  return (
    <div className="flex flex-col gap-4 h-full">
      <PanelGroup className="flex-1 min-h-0" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          <TrendSectionCard
            title="Buyers Trend"
            accent={BUY_ACCENT}
            count={selectedBuyers.length}
            searchBox={
              <SearchBox
                options={availableEntities}
                isMany={true}
                placeholder="Search Buyers"
                selectedOptions={selectedBuyers}
                onChange={setSelectedBuyers}
              />
            }
          >
            {loading ? (
              <ChartAreaLoader
                title="Loading Buyers Trend"
                subtitle="Fetching buyer trend data…"
              />
            ) : selectedBuyers.length === 0 ? (
              <EmptySelection
                accent={BUY_ACCENT}
                title="No Buyers Selected"
                message="Use the search above to pick one or more buyers to compare their trends."
              />
            ) : (
              <ReMixChart
                chartContainerHeight="calc(100vh - 370px)"
                data={chartBuyerData}
                showBrush={chartBuyerData.length > 96 ? true : undefined}
                brushStart={BrushStart.Start}
                isTimeSlot={false}
                yAxisLabel={"MWh"}
                secondYAxisLabel={"Rs/KWh"}
                onlyTitle={true}
                barCategoryGap={10}
                legends={getBuyersLegends()}
                hiddenLegends={["MCP"]}
                xDataKey={"date"}
              />
            )}
          </TrendSectionCard>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={80}>
          <TrendSectionCard
            title="Sellers Trend"
            accent={SELL_ACCENT}
            count={selectedSellers.length}
            searchBox={
              <SearchBox
                options={availableEntities}
                isMany={true}
                placeholder="Search Sellers"
                selectedOptions={selectedSellers}
                onChange={setSelectedSellers}
              />
            }
          >
            {loading ? (
              <ChartAreaLoader
                title="Loading Sellers Trend"
                subtitle="Fetching seller trend data…"
              />
            ) : selectedSellers.length === 0 ? (
              <EmptySelection
                accent={SELL_ACCENT}
                title="No Sellers Selected"
                message="Use the search above to pick one or more sellers to compare their trends."
              />
            ) : (
              <ReMixChart
                chartContainerHeight="calc(100vh - 370px)"
                data={chartSellerData}
                showBrush={chartSellerData.length > 96 ? true : undefined}
                brushStart={BrushStart.Start}
                isTimeSlot={false}
                yAxisLabel={"MWh"}
                secondYAxisLabel={"Rs/KWh"}
                onlyTitle={true}
                barCategoryGap={10}
                legends={getSellerLegends()}
                hiddenLegends={["MCP"]}
                xDataKey={"date"}
              />
            )}
          </TrendSectionCard>
        </Panel>
      </PanelGroup>
    </div>
  );
}

function EmptySelection({
  accent,
  title,
  message,
}: {
  accent: string;
  title: string;
  message: string;
}) {
  return (
    <div
      className="h-full min-h-[320px] flex flex-col items-center justify-center text-center px-6 py-10 rounded-xl border border-dashed"
      style={{
        borderColor: `${accent}66`,
        background: `${accent}08`,
      }}
    >
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
        style={{ background: `${accent}1A`, color: accent }}
      >
        <Search className="w-6 h-6" strokeWidth={2} />
      </div>
      <h4 className="text-base font-semibold text-gray-800">{title}</h4>
      <p className="mt-1.5 text-sm text-gray-500 max-w-xs">{message}</p>
    </div>
  );
}

function TrendSectionCard({
  title,
  accent,
  count,
  searchBox,
  children,
}: {
  title: string;
  accent: string;
  count: number;
  searchBox: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 h-full flex flex-col overflow-hidden shadow-sm">
      <div
        className="px-5 py-3 border-b border-gray-100"
        style={{
          background: `linear-gradient(90deg, ${accent}14 0%, transparent 60%)`,
        }}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <span
              className="w-1 h-8 rounded-full shrink-0"
              style={{ background: accent }}
            />
            <div className="min-w-0">
              <h4 className="text-base flex gap-x-0 items-center font-semibold text-[#6F6D7C] leading-tight">
                <span className="relative flex h-2 w-2">
                  <span
                    className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping"
                    style={{ background: accent }}
                  />
                  <span
                    className="relative inline-flex rounded-full h-2 w-2"
                    style={{ background: accent }}
                  />
                </span>
                &nbsp;{title}
              </h4>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <div className="min-w-[220px]">{searchBox}</div>
          </div>
        </div>
      </div>
      <div className="p-4 flex-1 overflow-hidden">{children}</div>
    </div>
  );
}
